import React from 'react';
import SocialModal from './SocialModal';

// The Dojo surface retains the existing membership, invite, and chat logic
// while owning a separate modal entry point and navigation chrome.
const DojoHomeModal = (props) => <SocialModal {...props} initialTab="dojo" dojoOnly />;

export default DojoHomeModal;
